/**
 * src/lib/cta-copy.ts — CRO P4: experimento "cta-copy-benefit-2026-q3".
 * Copy dos labels dos CTAs hero/after-vitrine por variante.
 * control = copy histórica; benefit = orientada a benefício.
 * SÓ os text nodes mudam — classes/animações/URLs/aria intactos (freeze).
 */
export const CTA_COPY_EXPERIMENT_ID = "cta-copy-benefit-2026-q3";

export const CTA_COPY = {
  control: {
    whatsapp: "GRUPO DO WHATSAPP",
    telegram: "GRUPO DO TELEGRAM",
  },
  benefit: {
    whatsapp: "QUERO AS PROMOS NO ZAP",
    telegram: "RECEBER NO TELEGRAM",
  },
} as const;

export type CtaCopyVariant = keyof typeof CTA_COPY;
